import { ChartsServices } from './apiServices/chartsApi';
import { CommentServices } from './apiServices/commentApi';
import { StoryServices } from './apiServices/storyApi';

export const ApiServices = {
  ...CommentServices,
  ...StoryServices,
  ...ChartsServices,
};
